'use client'

// src/utils/intent.ts
import { getItem, removeItem, setItem } from "@wbk/utils";
var saveSubscriptionIntent = ({ name, value }) => {
  const intent = {
    name,
    source: window.location.pathname,
    value: value || ""
  };
  setItem("subscription_intent", JSON.stringify(intent));
};
var getSubscriptionIntent = () => {
  const intent = getItem("subscription_intent");
  return intent ? JSON.parse(intent) : null;
};
var clearSubscriptionIntent = () => {
  removeItem("subscription_intent");
};

export {
  saveSubscriptionIntent,
  getSubscriptionIntent,
  clearSubscriptionIntent
};
//# sourceMappingURL=chunk-PQ5D4ZZX.mjs.map